import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-request-access-not-found-dialog',
  templateUrl: './request-access-not-found-dialog.component.html',
  styleUrls: ['./request-access-not-found-dialog.component.scss']
})
export class RequestAccessNotFoundDialogComponent implements OnInit {
  constructor(private readonly dialogRef: MatDialogRef<RequestAccessNotFoundDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}
}
